<template>
  <div class="page-pagination" ref="pagination">
    <el-pagination
      :align="align"
      :small="small"
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :layout="layout"
      :page-sizes="pageSizes"
      :total="total"
      v-bind="$attrs"
      :pager-count="5"
      @size-change="handleSizeChange" 
      @current-change="handleCurrentChange"
      ></el-pagination>
  </div>
</template>
<script>
export default {
  name: 'pagination',
  props: {
    align: {
      type: String,
      default: 'right'
    },
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 16, 20, 30, 40, 50, 100 ,200,300,500,800,1000]
      }
    },
    layout: {
      type: String,
      default: 'prev, pager, next'
    },
    background: {
      type: Boolean,
      default: true
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        this.$emit('update:limit', val)
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('pagination', { page: this.currentPage, limit: val })
    },
    handleCurrentChange(val) {
      this.$emit('pagination', { page: val, limit: this.pageSize })
    }
  }
}
</script>
<style>
.el-pager li{
  width: 40px;
  line-height: 40px;
  height: 40px;
  border: solid 1px #e3e3e3;
  font-size: 12px;
  font-weight: normal;
}
.el-pager li.btn-quicknext, .el-pager li.btn-quickprev{
  line-height: 40px;
}
.el-pagination button, .el-pagination span:not([class*=suffix]){
  border: solid 1px #e3e3e3;
  line-height: 40px;
  height: 40px;
  width: 40px;
}
.el-pagination .btn-next, .el-pagination .btn-prev{
  color: #e3e3e3;
}
.el-pagination .btn-next .el-icon, .el-pagination .btn-prev .el-icon{
  font-size: 20px;
}
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
  background-color: transparent;
}
.el-pagination.is-background .el-pager li:not(.disabled).active{
  color: #c8a979;
  border-color: #c8a979;
  background-color: transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/pagination.vue